import { useState } from 'react';
import { ReactMultiEmail } from 'react-multi-email';
import 'react-multi-email/dist/style.css';
import { Field, useField, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { setLeadData } from 'leadData/leadSlice';
import FeedbackMessage from '../FeedbackMessage';

import * as S from './styles';

export type MultiEmailsFieldType = {
  name: string;
  isValid?: boolean;
  feedbackMessage?: string | React.ReactNode;
  maxEmails?: number;
  autoFocus?: boolean;
};

export const MultiEmailsField = ({
  name,
  isValid,
  feedbackMessage,
  maxEmails,
  autoFocus = true,
}: MultiEmailsFieldType) => {
  const { inviteSent } = useSelector((state: RootState) => state.lead);

  const [emails, setEmails] = useState<string[]>([]);
  const [field, meta, helpers] = useField(name);
  const { resetForm } = useFormikContext();

  const dispatch = useDispatch();

  const { setValue } = helpers;

  const MultiEmails = () => {
    return (
      <>
        <ReactMultiEmail
          emails={emails}
          onChange={(_emails) => {
            setEmails(_emails);
            setValue(_emails.toString());
          }}
          autoFocus={autoFocus}
          getLabel={(email, index, removeEmail) => {
            if (inviteSent) {
              removeEmail(index);
              resetForm();
              dispatch(setLeadData({ inviteSent: false }));
            }
            return (
              <div data-tag key={index}>
                <div data-tag-item>{email}</div>
                <span data-tag-handle onClick={() => removeEmail(index)}>
                  ×
                </span>
              </div>
            );
          }}
        />
      </>
    );
  };

  return (
    <S.Wrapper>
      <Field name={name} as={MultiEmails} />

      {emails.length > 0 && (
        <S.InvitingText>
          Inviting{' '}
          <strong>
            {emails.length} {maxEmails ? `of ${maxEmails}` : ''}
          </strong>{' '}
            {emails.length > 1 ? 'friends' : 'friend'}{' '}
          to Savings.Club.
        </S.InvitingText>
      )}
      {!isValid && feedbackMessage && (
        <FeedbackMessage marginTop={8}>{feedbackMessage}</FeedbackMessage>
      )}
    </S.Wrapper>
  );
};

export default MultiEmailsField;
